// Jul-2026 (User-Wunsch) — Newsletter-Anmeldung auf der Startseite (Double-Opt-in).
import { useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import api from "../lib/api";

export const NewsletterSignup = () => {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const subscribe = async () => {
        if (!email.includes("@")) { toast.error("Bitte eine gültige E-Mail-Adresse eingeben."); return; }
        setBusy(true);
        try {
            const r = await api.post("/newsletter/subscribe", { email: email.trim() });
            setDone(true);
            toast.success(r.data.already_confirmed
                ? "Diese Adresse ist bereits angemeldet."
                : "Fast geschafft! Bitte bestätigen Sie den Link in Ihrer E-Mail.");
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Anmeldung fehlgeschlagen.");
        }
        setBusy(false);
    };

    return (
        <section className="max-w-7xl mx-auto px-4 md:px-8 mt-16 mb-8" data-testid="home-newsletter-signup">
            <div className="bg-[#111827] rounded-sm px-6 py-8 md:px-10 flex flex-col md:flex-row md:items-center gap-5">
                <div className="flex-1">
                    <div className="text-[#FFCC00] text-[10px] font-black uppercase tracking-[0.2em] mb-1 flex items-center gap-1.5">
                        <Mail className="w-3.5 h-3.5" /> Newsletter
                    </div>
                    <h2 className="font-display text-white font-black text-lg md:text-xl">Angebote &amp; Neuheiten direkt ins Postfach</h2>
                    <p className="text-gray-400 text-sm mt-1">Neue Fahrzeuge, Aktionen und Saison-Tipps — jederzeit abbestellbar.</p>
                </div>
                {done ? (
                    <div className="flex items-center gap-2 text-emerald-400 font-bold text-sm" data-testid="newsletter-signup-done">
                        <CheckCircle2 className="w-5 h-5" /> Bitte E-Mail bestätigen — danke!
                    </div>
                ) : (
                    <div className="flex w-full md:w-auto gap-2">
                        <input
                            type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && subscribe()}
                            placeholder="Ihre E-Mail-Adresse"
                            className="flex-1 md:w-72 h-11 rounded-sm px-3 text-sm bg-white border-0 focus:outline-none focus:ring-2 focus:ring-[#FFCC00]"
                            data-testid="newsletter-signup-input"
                        />
                        <button
                            type="button" onClick={subscribe} disabled={busy}
                            className="h-11 px-5 rounded-sm bg-[#FFCC00] text-[#111827] text-sm font-black hover:bg-yellow-400 transition-colors disabled:opacity-60 whitespace-nowrap"
                            data-testid="newsletter-signup-btn"
                        >
                            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Anmelden"}
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};
